import { Grid } from "@material-ui/core";
import React from "react";
import { ScriptFormInput } from "./ScriptFormInput";
import { FormPreview } from "./FormPreview";
import { CodePreview } from "./CodePreview";

const shadhow = "0px 10px 15px -3px rgba(0,0,0,0.1)";

export const FormGeneratorView = () => {
  return (
    <div
      style={{
        height: "80vh",
        overflow: "hidden",
        background: "white",
        borderRadius: 16,
        padding: 16,
        marginTop: 32,
        boxShadow: shadhow,
      }}
    >
      <Grid container spacing={2} style={{ boxShadow: shadhow }}>
        <Grid item xs={12} sm={4}>
          <ScriptFormInput />
          <FormPreview />
        </Grid>
        <Grid item xs={12} sm={8}>
          <CodePreview />
        </Grid>
      </Grid>
    </div>
  );
};
